function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (c = i[4] || 3, u = i[5] === e ? i[3] : i[5], i[4] = 3, i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); }; o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { projectAttributes } from '@bkry/bowline-redux/projects';
import { getWalletAttributes } from '@bkry/bowline-redux/wallets';
import { sha256 } from 'js-sha256';
import { useSsrState, useSsrEffect } from '@issr/core';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import { useWeb3React } from '@web3-react/core';
import { useWallet, useConnection } from '@solana/wallet-adapter-react';
import { utils, chains } from '@bkry/bowline-connectors';
import { useCallback } from 'react';

/**
 * Custom hook that returns the connected account address from either Ethereum or Solana wallets
 * @returns {string|null} The connected account address or null if no wallet is connected
 */
var useAccount = function useAccount() {
  var _wallet$publicKey;
  var _useWeb3React = useWeb3React(),
    web3Account = _useWeb3React.account,
    ethProvider = _useWeb3React.provider,
    ethConnector = _useWeb3React.connector,
    ethChainId = _useWeb3React.chainId;
  var wallet = useWallet();
  var _useConnection = useConnection(),
    connection = _useConnection.connection;
  var ethConnectorName = utils.getName(ethConnector);

  // Return Ethereum account or Solana publicKey (converted to string) or null
  var account = web3Account || (wallet !== null && wallet !== void 0 && wallet.publicKey ? wallet === null || wallet === void 0 || (_wallet$publicKey = wallet.publicKey) === null || _wallet$publicKey === void 0 ? void 0 : _wallet$publicKey.toBase58() : null);
  var solanaChainId = connection !== null && connection !== void 0 && connection.rpcEndpoint.includes("devnet") ? 1000000002 : 1000000001;
  var ethNetworkChange = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(chainHex, chainId) {
      var chainOptions,
        callback,
        _connector,
        _addChainParameters$r,
        addChainParameters,
        rpcUrls,
        _connector2,
        _args = arguments,
        _t,
        _t2,
        _t3;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            chainOptions = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            callback = _args.length > 3 && _args[3] !== undefined ? _args[3] : function () {};
            if (ethConnector) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            _context.p = 1;
            if (!(ethConnectorName === "BowlineWallet" && ethConnector.changeNetwork)) {
              _context.n = 3;
              break;
            }
            _context.n = 2;
            return ethConnector.changeNetwork(chainHex);
          case 2:
            callback(true);
            return _context.a(2);
          case 3:
            _context.p = 3;
            _context.n = 4;
            return (_connector = connector) === null || _connector === void 0 ? void 0 : _connector.provider.request({
              method: "wallet_switchEthereumChain",
              params: [{
                chainId: chainHex
              }]
            });
          case 4:
            callback(true);
            return _context.a(2);
          case 5:
            _context.p = 5;
            _t = _context.v;
            if (!(_t.code === networkChangeErrorCode)) {
              _context.n = 9;
              break;
            }
            addChainParameters = chains.getAddChainParameters(chainId);
            rpcUrls = (addChainParameters === null || addChainParameters === void 0 || (_addChainParameters$r = addChainParameters.rpcUrls) === null || _addChainParameters$r === void 0 ? void 0 : _addChainParameters$r.length) > 1 ? addChainParameters === null || addChainParameters === void 0 ? void 0 : addChainParameters.rpcUrls.filter(function (rpcUrl) {
              return !rpcUrl.includes("infura");
            }) : addChainParameters === null || addChainParameters === void 0 ? void 0 : addChainParameters.rpcUrls;
            _context.p = 6;
            _context.n = 7;
            return (_connector2 = connector) === null || _connector2 === void 0 ? void 0 : _connector2.provider.request({
              method: "wallet_addEthereumChain",
              params: [_objectSpread({
                rpcUrls: rpcUrls,
                nativeCurrency: addChainParameters.nativeCurrency,
                chainName: addChainParameters.chainName,
                chainId: chainHex
              }, chainOptions)]
            });
          case 7:
            callback(true);
            _context.n = 9;
            break;
          case 8:
            _context.p = 8;
            _t2 = _context.v;
            callback(false);
          case 9:
            _context.n = 11;
            break;
          case 10:
            _context.p = 10;
            _t3 = _context.v;
            console.error("Error switching Ethereum network:", _t3);
          case 11:
            return _context.a(2);
        }
      }, _callee, null, [[6, 8], [3, 5], [1, 10]]);
    }));
    return function ethNetworkChange(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    account: account,
    isEth: !!web3Account,
    ethProvider: ethProvider,
    ethConnector: ethConnector,
    ethConnectorName: ethConnectorName,
    ethChainId: ethChainId,
    ethNetworkChange: ethNetworkChange,
    isSol: !!(wallet !== null && wallet !== void 0 && wallet.publicKey),
    solanaPublicKey: wallet === null || wallet === void 0 ? void 0 : wallet.publicKey,
    solanaConnection: connection,
    solanaWallet: wallet,
    solanaChainId: solanaChainId
  };
};
var useAuthorization = function useAuthorization() {
  var location = useLocation();
  var _useSsrState = useSsrState(null, "state-5a30c9318937b342f96286847ea9fe2e-8"),
    _useSsrState2 = _slicedToArray(_useSsrState, 2),
    isAuthorized = _useSsrState2[0],
    setIsAuthorized = _useSsrState2[1];
  var _useSsrState3 = useSsrState(null, "state-5a30c9318937b342f96286847ea9fe2e-9"),
    _useSsrState4 = _slicedToArray(_useSsrState3, 2),
    isBlocked = _useSsrState4[0],
    setIsBlocked = _useSsrState4[1];
  var cookieHandler = new Cookies();
  var _useAccount = useAccount(),
    account = _useAccount.account;
  var project = useSelector(projectAttributes);
  var wallet = useSelector(function (state) {
    return getWalletAttributes(state, account);
  });
  var signedIn = useSelector(function (state) {
    return state.wallets.siweSuccess || state.wallets.siwsSuccess;
  });
  useSsrEffect(function () {
    if (project !== null && project !== void 0 && project.access_mode) {
      switch (project.access_mode) {
        case "anyone":
          setIsAuthorized(true);
          setIsBlocked(false);
          break;
        case "connected_wallets":
          setIsAuthorized(!!account);
          setIsBlocked(!account);
          break;
        case "signed_in_wallets":
          setIsAuthorized(signedIn);
          setIsBlocked(!signedIn);
          break;
        case "holder_wallets":
          var isMintRoute = /minting/i.test(location.pathname);
          setIsAuthorized(signedIn && (wallet === null || wallet === void 0 ? void 0 : wallet.current_wallet_is_holder));
          setIsBlocked(!signedIn || !(wallet !== null && wallet !== void 0 && wallet.current_wallet_is_holder) && !isMintRoute);
          break;
        case "password":
          var accessKey = cookieHandler.get("access_key") || "";
          setIsAuthorized(sha256(accessKey).toString() === (project === null || project === void 0 ? void 0 : project.access_key));
          setIsBlocked(false);
          break;
      }
    }
  }, [project, account, signedIn, wallet, cookieHandler, setIsAuthorized, setIsBlocked], "ssr-effect-5a30c9318937b342f96286847ea9fe2e-4");
  return {
    isAuthorized: isAuthorized,
    isBlocked: isBlocked
  };
};
var useTransactionTimer = function useTransactionTimer(processing) {
  var _useSsrState5 = useSsrState(0, "state-7c08aedf2b89aa511a15694ac391ed5e-4"),
    _useSsrState6 = _slicedToArray(_useSsrState5, 2),
    transactionTimeInSeconds = _useSsrState6[0],
    setTransactionTimeInSeconds = _useSsrState6[1];
  var incrementTransactionTime = useCallback(function () {
    var timer;
    if (processing) {
      timer = setTimeout(function () {
        setTransactionTimeInSeconds(function (time) {
          return time + 1;
        });
      }, 1000);
    }
    return function () {
      return clearTimeout(timer);
    };
  }, [processing]);
  useSsrEffect(function () {
    var timerCleanup = incrementTransactionTime();
    return function () {
      return timerCleanup();
    };
  }, [transactionTimeInSeconds, processing, incrementTransactionTime], "ssr-effect-7c08aedf2b89aa511a15694ac391ed5e-4");
  var resetTransactionTimer = useCallback(function () {
    setTransactionTimeInSeconds(0);
  }, []);
  return [transactionTimeInSeconds, resetTransactionTimer];
};
export { useAccount, useAuthorization, useTransactionTimer };
//# sourceMappingURL=index.js.map
